import { CollectionName } from '@livv/models';
import { collection } from 'firebase/firestore';
import { db } from 'services/firebase';

export const users = collection(db, CollectionName.USERS);
export const userPrivileges = collection(db, CollectionName.USER_PRIVILEGES);
